import { HTTP } from '@/common/utils/http';
import { PaginationParams } from '@/common/utils/pagination-params';
import { mapBodyParams } from '@/common/utils/mapBodyParams';
import { QueryParams } from '@/common/utils/query-params';

export const ActivityDetailsService = {
    getChildrenByActivity({ activityType, listType, schoolId, activityId, params }) {
        return this[`get${listType}`](activityType, schoolId, activityId, params);
    },

    getRosters(activityType, schoolId, activityId, params) {
        return this[`getRostersBy${activityType}`](schoolId, activityId, params);
    },

    getWaitlist(activityType, schoolId, activityId, params) {
        return this[`getWaitlistBy${activityType}`](schoolId, activityId, params);
    },

    getDropin(activityType, schoolId, activityId, params) {
        return this[`getDropinBy${activityType}`](schoolId, activityId, params);
    },

    getAttendancesList({ activityType, schoolId, activityId, params }) {
        return this[`getAttendancesListBy${activityType}`](schoolId, activityId, params);
    },

    getAttendanceStatisticsByActivity({ schoolId, activityId, activityType, date }) {
        return this[`getAttendanceStatisticsBy${activityType}`](schoolId, activityId, date);
    },

    setActivityAttendanceCheckIn({ schoolId, activityId, activityType, checkIn, attendanceIds }) {
        return this[`set${activityType}AttendanceCheckIn`]({ schoolId, activityId, checkIn, attendanceIds });
    },

    removeActivityAttendanceCheckIn({ schoolId, activityId, activityType, attendanceId }) {
        return this[`remove${activityType}AttendanceCheckIn`]({ schoolId, activityId, attendanceId });
    },

    setActivityAttendanceCheckOut({ schoolId, activityId, activityType, checkOut, attendanceIds, checkOutPerson }) {
        return this[`set${activityType}AttendanceCheckOut`]({ schoolId, activityId, checkOut, attendanceIds, checkOutPerson });
    },

    removeActivityAttendanceCheckOut({ schoolId, activityId, activityType, attendanceId }) {
        return this[`remove${activityType}AttendanceCheckOut`]({ schoolId, activityId, attendanceId });
    },

    getDatesForCalendarByActivity({ schoolId, activityId, activityType }) {
        return this[`getDatesForCalendarBy${activityType}`](schoolId, activityId);
    },

    getDropInDates({ schoolId, activityId, childId, activityType }) {
        return this[`getDropInDatesFor${activityType}`](schoolId, activityId, childId);
    },

//Class
    getClassXlsFileFieldsNames(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/rosters/xls-fields`);
    },

    getClassDetailsXls(schoolId, classId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/classes/${classId}/rosters/xls`);
        return HTTP.get(url);
    },

 //Class Rosters
    getRostersByClass(schoolId, classId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/classes/${classId}/rosters`);
        return HTTP.get(url);
    },

    removeChildFromClassRosters(schoolId, classId, rosterId) {
            return HTTP.delete(`schools/${schoolId}/classes/${classId}/rosters/${rosterId}`);
    },

    removeChildrenFromClassRosters(schoolId, activityId, rosterIds) {
        return HTTP.delete(`schools/${schoolId}/classes/${activityId}/rosters?rosterIds=${rosterIds}`);
    },

    removeChildWithoutPaymentFromClassRosters(schoolId, activityId, childId) {
        return HTTP.delete(`schools/${schoolId}/classes/${activityId}/rosters/children/${childId}`);
    },

    sendEmailToClassRosters(schoolId, classId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/classes/${classId}/rosters/children/parents/email`, formData, { headers });
    },

    sendSMSToClassRosters(schoolId, classId, form) {
        return HTTP.post(`/schools/${schoolId}/classes/${classId}/rosters/children/parents/sms`, form);
    },

    getChildInfoForClassRostersEdit(schoolId, classId, rosterId) {
        return HTTP.get(`schools/${schoolId}/classes/${classId}/rosters/${rosterId}/update-info`);
    },

    getClassRosterRequired(schoolId, classId) {
        return HTTP.get(`schools/${schoolId}/classes/${classId}/details`);
    },

    editClassRosters(schoolId, classId, rosterId, form) {
        return HTTP.put(`schools/${schoolId}/classes/${classId}/rosters/${rosterId}`, mapBodyParams(form));
    },

    editMultipleClassRosters(schoolId, classId, form) {
        return HTTP.put(`schools/${schoolId}/classes/${classId}/rosters`, mapBodyParams(form));
    },

    addChildToClassRosters(schoolId, classId, form) {
        return HTTP.post(`/schools/${schoolId}/classes/${classId}/rosters`, mapBodyParams(form));
    },

 //Class Waitlist
    getWaitlistByClass(schoolId, classId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/classes/${classId}/waitlist`);
        return HTTP.get(url);
    },

    addChildToClassWaitlist(schoolId, classId, form) {
        // @NotNull private Long classId;

        // @NotNull private Long childId;
      
        // @Positive private Long pickUpOptionId;
      
        // @Positive private Long teacherId;
      
        // @Positive private Long tShirtSizeId;
      
        // private List<Long> addOnIds = new ArrayList<>(0);
        return HTTP.post(`/schools/${schoolId}/classes/${classId}/waitlist`, mapBodyParams(form));
    },

    removeChildFromClassWaitlist(schoolId, classId, rosterId) {
        return HTTP.delete(`schools/${schoolId}/classes/${classId}/waitlist/${rosterId}`);
    },

    removeChildrenFromClassWaitlist(schoolId, activityId, rosterIds) {
        return HTTP.delete(`schools/${schoolId}/classes/${activityId}/waitlist?rosterIds=${rosterIds}`);
    },

 //Class Attendance
    getAttendancesListByClass(schoolId, classId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/classes/${classId}/attendances`);
        return HTTP.get(url);
    },

    getAttendanceStatisticsByClass(schoolId, classId, date) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/attendances/statistics?date=${date}`)
    },

    getDatesForCalendarByClass(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/dates`);
    },

    setClassAttendanceCheckIn({ schoolId, activityId, checkIn, attendanceIds }) {
        return HTTP.patch(`/schools/${schoolId}/classes/${activityId}/attendances/check-in`, {
            checkIn,
            attendanceIds
        });
    },

    removeClassAttendanceCheckIn({ schoolId, activityId, attendanceId }) {
        return HTTP.delete(`/schools/${schoolId}/classes/${activityId}/attendances/${attendanceId}/check-in` );
    },

    setClassAttendanceCheckOut({ schoolId, activityId, checkOut, attendanceIds, checkOutPerson }) {
        return HTTP.patch(`/schools/${schoolId}/classes/${activityId}/attendances/check-out`, {
            checkOut,
            attendanceIds,
            checkOutPerson
        });
    },

    removeClassAttendanceCheckOut({ schoolId, activityId, attendanceId }) {
        return HTTP.delete(`/schools/${schoolId}/classes/${activityId}/attendances/${attendanceId}/check-out`);
    },

    getClassAttendanceXlsFileFieldsNames(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/attendances/xls-fields`);
    },

    getClassAttendanceXls(schoolId, classId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/classes/${classId}/attendances/xls-file`);
        return HTTP.get(url);
    },

    sendEmailClassAttendance(schoolId, classId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`schools/${schoolId}/classes/${classId}/attendances/children/parents/email`, formData, { headers });
    },

    sendSMSClassAttendance(schoolId, classId, form) {
        return HTTP.post(`schools/${schoolId}/classes/${classId}/attendances/children/parents/sms`, form);
    },


//Camp
    getCampXlsFileFieldsNames(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/xls-fields`);
    },

    getCampDetailsXls(schoolId, campPricingId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/xls`);
        return HTTP.get(url);
    },

 //Camp Rosters
    getRostersByCamp(schoolId, campId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camp-pricing/${campId}/rosters`);
        return HTTP.get(url);
    },

    removeChildFromCampRosters(schoolId, campPricingId, rosterId) {
        return HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters/${rosterId}`);
    },

    removeChildrenFromCampRosters(schoolId, campPricingId, rosterIds) {
        return HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters?rosterIds=${rosterIds}`);
    },

    removeChildWithoutPaymentFromCampRosters(schoolId, activityId, childId) {
        return HTTP.delete(`schools/${schoolId}/camp-pricing/${activityId}/rosters/children/${childId}`);
    },

    getChildInfoForCampRostersEdit(schoolId, campPricingId, rosterId) {
        return HTTP.get(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters/${rosterId}/update-info`);
    },

    getCampRosterRequired(schoolId, campPricingId) {
        return HTTP.get(`schools/${schoolId}/camp-pricings/${campPricingId}/details`);
    },

    editCampRosters(schoolId, campPricingId, rosterId, form) {
        return HTTP.put(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters/${rosterId}`, mapBodyParams(form));
    },

    editMultipleCampRosters(schoolId, campPricingId, form) {
        return HTTP.put(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters`, mapBodyParams(form));
    },

    sendEmailToCampRosters(schoolId, campPricingId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/children/parents/email`, formData, { headers });
    },

    sendSMSToCampRosters(schoolId, campPricingId, form) {
        return HTTP.post(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/children/parents/sms`, form);
    },

    addChildToCampRosters(schoolId, campPricingId, form) {
        return HTTP.post(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters`, mapBodyParams(form));
    },

 //Camp Waitlist
    getWaitlistByCamp(schoolId, campId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camp-pricing/${campId}/wait-list`);
        return HTTP.get(url);
    },

    addChildToCampWaitlist(schoolId, campPricingId, form) {
        // @NotNull private Long campPricingId;

        // @NotNull private Long childId;
      
        // @Positive private Long pickUpOptionId;
      
        // @Positive private Long teacherId;
      
        // @Positive private Long tShirtSizeId;
      
        // private List<Long> addOnIds = new ArrayList<>(0);
        return HTTP.post(`/schools/${schoolId}/camp-pricing/${campPricingId}/wait-list`, mapBodyParams(form));
    },

    removeChildFromCampWaitlist(schoolId, campPricingId, rosterId) {
        return HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/wait-list/${rosterId}`);
    },

    removeChildrenFromCampWaitlist(schoolId, campPricingId, rosterIds) {
        return HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/wait-list?rosterIds=${rosterIds}`);
    },

 //Camp Attendance
    getAttendancesListByCamp(schoolId, campId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camps/${campId}/attendances`);
        return HTTP.get(url);
    },

    getAttendanceStatisticsByCamp(schoolId, campId, date) {
        return HTTP.get(`/schools/${schoolId}/camps/${campId}/attendances/statistics?date=${date}`)
    },

    getDatesForCalendarByCamp(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camp-pricing/${campPricingId}/dates`);
    },

    setCampAttendanceCheckIn({ schoolId, activityId, checkIn, attendanceIds }) {
        return HTTP.patch(`/schools/${schoolId}/camps/${activityId}/attendances/check-in`, { checkIn, attendanceIds });
    },

    removeCampAttendanceCheckIn({ schoolId, activityId, attendanceId }) {
        return HTTP.delete(`/schools/${schoolId}/camps/${activityId}/attendances/${attendanceId}/check-in`);
    },

    setCampAttendanceCheckOut({ schoolId, activityId, checkOut, attendanceIds, checkOutPerson }) {
        return HTTP.patch(`/schools/${schoolId}/camps/${activityId}/attendances/check-out`, {
            checkOut,
            attendanceIds,
            checkOutPerson
        });
    },

    removeCampAttendanceCheckOut({ schoolId, activityId, attendanceId }) {
        return HTTP.delete(`/schools/${schoolId}/camps/${activityId}/attendances/${attendanceId}/check-out`);
    },

    getCampAttendanceXlsFileFieldsNames(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camps/${campPricingId}/attendances/xls-fields`);
    },

    getCampAttendanceXls(schoolId, campPricingId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camps/${campPricingId}/attendances/xls-file`);
        return HTTP.get(url);
    },

    sendEmailCampAttendance(schoolId, campPricingId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`schools/${schoolId}/camps/${campPricingId}/attendances/children/parents/email`, formData, { headers });
    },

    sendSMSCampAttendance(schoolId, campPricingId, form) {
        return HTTP.post(`schools/${schoolId}/camps/${campPricingId}/attendances/children/parents/sms`, form);
    },


//Aftercare
 //Aftercare Rosters
    async getRostersByAftercare(schoolId, activityId, params) {
        const { data } = await HTTP.get(`/schools/${schoolId}/aftercare-day/${activityId}/aftercare-id`);
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare/${data}/rosters/aftercare-day/${activityId}`);
        return HTTP.get(url);
    },

    getAftercareRosterRequired(schoolId, aftercareId) {
        return HTTP.get(`schools/${schoolId}/aftercare/${aftercareId}/details`);
    },

    addChildToAftercareRosters(schoolId, aftercareId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare/${aftercareId}/rosters`, mapBodyParams(form));
    },

    removeChildFromAftercareRosters(schoolId, aftercareId, rosterId, aftercareDayId) {
        return HTTP.delete(`schools/${schoolId}/aftercare/${aftercareId}/rosters/${rosterId}/aftercare-day/${aftercareDayId}`);
    },

    removeChildWithoutPaymentFromAftercareRosters(schoolId, activityId, childId) {
        return HTTP.delete(`schools/${schoolId}/aftercare/${activityId}/rosters/children/${childId}`);
    },

    removeChildrenFromAftercareRosters(schoolId, aftercareDayId, rosterIds, aftercareId) {
        return HTTP.delete(`schools/${schoolId}/aftercare/${aftercareId}/rosters/aftercare-day/${aftercareDayId}?rosterIds=${rosterIds}`);
    },

    sendEmailToAftercareRosters(schoolId, aftercareId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/aftercare/${aftercareId}/rosters/children/parents/email`, formData, { headers });
    },

    sendSMSToAftercareRosters(schoolId, aftercareId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare/${aftercareId}/rosters/children/parents/sms`, form);
    },

    getAftercareRostersXlsFileFieldsNames(schoolId, aftercareId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/rosters/aftercare-day/${aftercareDayId}/xls-fields`);
    },

    getAftercareRostersXlsFile(schoolId, aftercareId, aftercareDayId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare/${aftercareId}/rosters/aftercare-day/${aftercareDayId}/xls`);
        return HTTP.get(url);
    },

    getChildInfoForAftercareRostersEdit(schoolId, aftercareId, rosterId) {
        return HTTP.get(`schools/${schoolId}/aftercare/${aftercareId}/rosters/${rosterId}/update-info`);
    },

    editAftercareRosters(schoolId, aftercareId, rosterId, form) {
        return HTTP.put(`schools/${schoolId}/aftercare/${aftercareId}/rosters/${rosterId}`, mapBodyParams(form));
    },

    editMultipleAftercareRosters(schoolId, aftercareId, form) {
        return HTTP.put(`schools/${schoolId}/aftercare/${aftercareId}/rosters`, mapBodyParams(form));
    },

 //Aftercare Waitlist
    async getWaitlistByAftercare(schoolId, activityId, params) {
        const { data } = await HTTP.get(`/schools/${schoolId}/aftercare-day/${activityId}/aftercare-id`);
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare/${data}/waitlist/aftercare-day/${activityId}`);
        return HTTP.get(url);
    },

    addChildToAftercareWaitlist(schoolId, aftercareId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare/${aftercareId}/waitlist`, mapBodyParams(form));
    },

    removeChildFromAftercareWaitlist(schoolId, aftercareDayId, rosterId) {
        return HTTP.delete(`schools/${schoolId}/aftercare-day/${aftercareDayId}/wait-list/${rosterId}`);
    },

    removeChildrenFromAftercareWaitlist(schoolId, aftercareDayId, rosterIds) {
        return HTTP.delete(`schools/${schoolId}/aftercare-day/${aftercareDayId}/wait-list?rosterIds=${rosterIds}`);
    },

 //Aftercare DropIn
    async getDropinByAftercare(schoolId, activityId, params) {
        const { data } = await HTTP.get(`/schools/${schoolId}/aftercare-day/${activityId}/aftercare-id`);
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare/${data}/drop-in/aftercare-day/${activityId}`);
        return HTTP.get(url);
    },

    addChildToAftercareDropin(schoolId, aftercareId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare/${aftercareId}/drop-in`, mapBodyParams(form));
    },

    getDropInDatesForAftercare(schoolId, activityId, childId) {
        return HTTP.get(`/schools/${schoolId}/aftercare/${activityId}/children/${childId}/dates`);
    },

    getAftercareDropInXlsFileFieldsNames(schoolId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/xls-fields`);
    },

    getAftercareDropInXlsFile(schoolId, aftercareDayId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/xls`);
        return HTTP.get(url);
    },

    sendEmailToAftercareDropIn(schoolId, aftercareDayId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/children/parents/email`, formData, { headers });
    },

    sendSMSToAftercareDropIn(schoolId, aftercareDayId, form) {
        return HTTP.post(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/children/parents/sms`, form);
    },

    removeChildFromAftercareDropin(schoolId, aftercareDayId, dropInId) {
        return HTTP.delete(`schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/${dropInId}`);
    },

    removeChildrenFromAftercareDropin(schoolId, aftercareDayId, dropInIds) {
        return HTTP.delete(`schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in?dropInIds=${dropInIds}`);
    },

    removeChildWithoutPaymentFromAftercareDropin(schoolId, activityId, childId) {
        return HTTP.delete(`schools/${schoolId}/aftercare/${activityId}/drop-in/children/${childId}`);
    },

    editMultipleAftercareDropin(schoolId, aftercareDayId, form) {
        return HTTP.put(`schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in`, mapBodyParams(form));
    },

    getChildInfoForAftercareDropinEdit(schoolId, aftercareId, id, aftercareDayId) {
        return HTTP.get(`schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/${id}/update-info`);
    },

    editAftercareDropin(schoolId, aftercareDayId, id, form) {
        return HTTP.put(`schools/${schoolId}/aftercare-day/${aftercareDayId}/drop-in/${id}`, mapBodyParams(form));
    },

 //Aftercare Attendance
    getAttendancesListByAftercare(schoolId, activityId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare-day/${activityId}/attendances`);
        return HTTP.get(url);
    },

    getAttendanceStatisticsByAftercare(schoolId, activityId, date) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${activityId}/attendances/statistics?date=${date}`);
    },

    getDatesForCalendarByAftercare(schoolId, activityId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${activityId}/dates`);
    },

    getAftercareAttendanceXlsFileFieldsNames(schoolId, aftercareDayId) {
        return HTTP.get(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/attendances/xls-fields`);
    },

    getAftercareAttendanceXls(schoolId, aftercareDayId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/aftercare-day/${aftercareDayId}/attendances/xls-file`);
        return HTTP.get(url);
    },

    sendEmailAftercareAttendance(schoolId, aftercareDayId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`schools/${schoolId}/aftercare-day/${aftercareDayId}/attendances/children/parents/email`, formData, { headers });
    },

    sendSMSAftercareAttendance(schoolId, aftercareDayId, form) {
        return HTTP.post(`schools/${schoolId}/aftercare-day/${aftercareDayId}/attendances/children/parents/sms`, form);
    },

    setAftercareAttendanceCheckIn({ schoolId, activityId, checkIn, attendanceIds }) {
        return HTTP.patch(`/schools/${schoolId}/aftercare-day/${activityId}/attendances/check-in`, { checkIn, attendanceIds });
    },

    removeAftercareAttendanceCheckIn({ schoolId, activityId, attendanceId }) {
        return HTTP.delete(`/schools/${schoolId}/aftercare-day/${activityId}/attendances/${attendanceId}/check-in`);
    },

    setAftercareAttendanceCheckOut({ schoolId, activityId, checkOut, attendanceIds, checkOutPerson }) {
        return HTTP.patch(`/schools/${schoolId}/aftercare-day/${activityId}/attendances/check-out`, {
            checkOut,
            attendanceIds,
            checkOutPerson
        });
    },

    removeAftercareAttendanceCheckOut({ schoolId, activityId, attendanceId }) {
        return HTTP.delete(`/schools/${schoolId}/aftercare-day/${activityId}/attendances/${attendanceId}/check-out`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/activity-details.service.js